import { TmrBaseResource } from 'stylewhere/api'

export class Checklist extends TmrBaseResource {
  static endpoint = 'logistics/api/v1/checklists'
}
